import { AmountDto } from "./amount.dto"

export class AccountBalanceResponseDto {
  balanceAmount?: AmountDto;
  balanceType?: string;
  creditLimitIncluded?: boolean;
  lastChangeDateTime?: string;
  lastCommittedTransaction?: string;
  referenceDate?: string;
}

export class AccountBalancesResponseDto {
  balances: AccountBalanceResponseDto[]
}